import { useModalStore } from "../store/modalStore";
import type { ModalType } from "../store/modalStore";

export const useModal = () => {
	const {
		showCancelModal,
		showConfirmModal,
		showErrorModal,
		modalTitle,
		modalMessage,
		modalType,
		onConfirm,
		onCancel,
		setShowCancelModal,
		setShowConfirmModal,
		setShowErrorModal,
		setModalContent,
		resetModals,
	} = useModalStore();

	const showModal = (
		type: ModalType,
		title: string,
		message: string,
		onConfirm?: () => void,
		onCancel?: () => void,
	) => {
		setModalContent(title, message, type, onConfirm, onCancel);
		switch (type) {
			case "cancel":
				setShowCancelModal(true);
				break;
			case "confirm":
				setShowConfirmModal(true);
				break;
			case "error":
				setShowErrorModal(true);
				break;
		}
	};

	const hideModal = (type: ModalType) => {
		switch (type) {
			case "cancel":
				setShowCancelModal(false);
				break;
			case "confirm":
				setShowConfirmModal(false);
				break;
			case "error":
				setShowErrorModal(false);
				break;
		}
	};

	return {
		// State
		showCancelModal,
		showConfirmModal,
		showErrorModal,
		modalTitle,
		modalMessage,
		modalType,
		onConfirm,
		onCancel,

		// Actions
		showModal,
		hideModal,
		resetModals,
	};
};
